import { apiClient } from '@/api/client'
import type {
  AutomationRecipe,
  AutomationRecipeInput,
  AutomationRun,
  AutomationSettings,
  PendingAction,
} from './types'

/** Edited payload + dismiss reason for an approval-queue decision. */
export interface ApprovalDecision {
  editedPayload?: Record<string, unknown>
  dismissReason?: string
}

export const automationApi = {
  listRecipes: () =>
    apiClient.get<AutomationRecipe[]>('/automation/recipes').then((r) => r.data),
  createRecipe: (body: AutomationRecipeInput) =>
    apiClient.post<AutomationRecipe>('/automation/recipes', body).then((r) => r.data),
  updateRecipe: (id: number, body: AutomationRecipeInput) =>
    apiClient.put<AutomationRecipe>(`/automation/recipes/${id}`, body).then((r) => r.data),
  deleteRecipe: (id: number) =>
    apiClient.delete(`/automation/recipes/${id}`).then(() => undefined),
  toggleRecipe: (id: number, enabled: boolean) =>
    apiClient.patch<AutomationRecipe>(`/automation/recipes/${id}/enabled`, { enabled }).then((r) => r.data),

  getSettings: () =>
    apiClient.get<AutomationSettings>('/automation/settings').then((r) => r.data),
  updateSettings: (autoSend: boolean) =>
    apiClient.put<AutomationSettings>('/automation/settings', { autoSend }).then((r) => r.data),
  setEnabled: (enabled: boolean) =>
    apiClient.put<AutomationSettings>('/automation/settings/enabled', { enabled }).then((r) => r.data),

  listRuns: (triggerRefId?: number) =>
    apiClient
      .get<AutomationRun[]>('/automation/runs', {
        params: triggerRefId != null ? { triggerRefId } : undefined,
      })
      .then((r) => r.data),

  listPending: () =>
    apiClient.get<PendingAction[]>('/automation/pending').then((r) => r.data),
  approve: (id: number, body?: ApprovalDecision) =>
    apiClient.post<PendingAction>(`/automation/pending/${id}/approve`, body ?? {}).then((r) => r.data),
  dismiss: (id: number, body?: ApprovalDecision) =>
    apiClient.post(`/automation/pending/${id}/dismiss`, body ?? {}).then(() => undefined),
}
